// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1AxTu","placeholdersHeader":"styles_placeholdersHeader__2FC-p","editorStyle":"styles_editorStyle__Vce_g","placeholdersBox":"styles_placeholdersBox__3siwf"};